export enum EEnvironment {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}
